import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for scoring a successful Deuce (Indoor Football).
 * A Deuce is when a kickoff goes through the uprights for 2 points.
 * This is a state gate only; scoring logic is in DeuceGoodNotAffectedByPenalty.
 */
export default class DeuceGood extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.DeuceGood;
    }
}
